import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 1,
    backgroundColor: '#fff',
    color: theme.palette.grey[500],
    width: 57,
    height: 57,
    display: 'flex',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.grey[700]}`,
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    border: 'unset',
    cursor: 'pointer',
  },
}));
